import React, { ReactNode } from 'react';

import { Button, Checkbox } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';
import { ListPagination } from '../../ListPagination/ListPagination';

interface ICardListConstructor {
  childRef: any;
  paginationCallback?: (newList: any) => void;
  pureData?: any[];
  data: {
    header: {
      text: string;
      sideIcon: any;
      action: () => void;
      size: string | '1%';
      dropdown: ReactNode;
    }[];
    cardsList: {
      value: string;
      subValue: string;
      icon: any;
      textColor: string;
      size: string | '1%';
    }[][];
    innerData;
  };
  checkeds: string[];
  setCheckeds: (checked: string[]) => void;
  handleApprove: any;
  isApproveLoading: string[];
  handleDelete: any;
  isDeleteLoading: string[];
  isAllLoading: boolean;
}

const ManageCardListConstructor: React.FC<ICardListConstructor> = ({
  data,
  paginationCallback,
  pureData,
  childRef,
  checkeds,
  setCheckeds,
  handleApprove,
  isApproveLoading,
  handleDelete,
  isDeleteLoading,
  isAllLoading,
}) => {
  const { header, cardsList, innerData } = data;
  const cardsListLimited = cardsList?.slice(0, 10);

  const values = cardsListLimited?.map((card) => {
    const [{ value }] = card;

    return value;
  });

  return (
    <Div>
      <div className='unknown-header-table'>
        <Checkbox
          className='unknown-checkbox'
          checked={values.every((item) => checkeds.includes(item))}
          onChange={({ target }) => {
            if (target.checked) {
              setCheckeds([...checkeds, ...values]);
            } else {
              setCheckeds(
                checkeds.filter((checked) => !values.includes(checked)),
              );
            }
          }}
        />

        <div className='header_list_constructor'>
          {header?.map((item) => (
            <div
              key={item.text}
              className='header_item'
              style={{ flexBasis: item.size }}
              onClick={item.action}
            >
              {item.text}
              <div className='header-icon-container'>{item.sideIcon}</div>
              {item.dropdown}
            </div>
          ))}
        </div>
      </div>
      <div className='cards_list'>
        {cardsListLimited?.map((card, index) => {
          const [{ value }] = card;

          return (
            <div className='unknown-table-list' key={'card' + index}>
              <Checkbox
                className='unknown-checkbox'
                checked={checkeds.includes(value)}
                onChange={({ target }) => {
                  if (target.checked) {
                    setCheckeds([...checkeds, value]);
                  } else {
                    setCheckeds(
                      checkeds.filter((checked) => checked !== value),
                    );
                  }
                }}
              />

              <div className='card_in_list'>
                <div className='card_header'>
                  {card.map(({ icon, subValue, value, size }, index) => (
                    <div
                      key={'value-' + index}
                      className='card_values'
                      style={{ flexBasis: size }}
                    >
                      {icon}
                      <div className='card_value_label'>
                        <p className='main_card_text'>{value}</p>
                        <p className='sub_card_text'>{subValue}</p>
                      </div>
                    </div>
                  ))}

                  <div className='manage_buttons'>
                    <Button
                      type='primary'
                      loading={isApproveLoading.includes(value)}
                      onClick={() => {
                        handleApprove(
                          card[0]?.value,
                          innerData[index]?.tenantPk,
                        );
                      }}
                      disabled={isDeleteLoading.includes(value) || isAllLoading}
                    >
                      {T('Approve')}
                    </Button>

                    <Button
                      danger
                      type='primary'
                      loading={isDeleteLoading.includes(value)}
                      onClick={() => {
                        handleDelete(card[0]?.value);
                      }}
                      disabled={
                        isApproveLoading.includes(value) || isAllLoading
                      }
                    >
                      {T('Delete')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {
          <ListPagination
            ownRef={childRef}
            callback={paginationCallback}
            pureData={pureData}
          />
        }
      </div>
    </Div>
  );
};

export default ManageCardListConstructor;

const Div = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  color: #444;

  .unknown-header-table {
    margin-top: 25px;
    display: flex;
    position: relative;
    align-items: center;
  }

  .unknown-table-list {
    display: flex;
    position: relative;
    align-items: center;
  }

  .unknown-checkbox {
    margin-right: 16px;
    margin-left: 24px;
  }

  .header_list_constructor {
    position: sticky;
    top: 64px;
    left: 0;
    height: 50px;
    width: 96%;
    margin: 0;
    display: flex;
    flex-direction: row;
    font-weight: 400;
    font-size: 14px;
    color: #444;
    z-index: 4;
    pointer-events: none;
  }

  .header_item {
    display: flex;
    align-items: center;
    padding-right: 5px;
    padding-left: 20px;
    height: 50px;
    user-select: none;
    pointer-events: all;
    transition: background-color 200ms ease-in-out;
    position: relative;
    font-weight: 700;

    :hover .polygon path {
      fill: ${COLORS.primary};
    }

    .connector_header_item_clicked {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }
  }

  .card_in_list {
    width: 96%;
    height: 55px;
    margin: 5px 0;
    border-radius: 8px;
    transition: height ease-in-out 200ms;
    background-color: #fff;
    overflow: hidden;
    border: 1px solid #fff;

    :hover {
      border-color: #c4c3c3;
    }
  }

  .card_header {
    display: flex;
    flex-direction: row;
    height: 55px;
    user-select: none;

    .card_values {
      padding-left: 20px;
      display: flex;
      align-items: center;
    }

    .card_value_label {
      .main_card_text {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
      }
      .sub_card_text {
        margin: 0;
        font-size: 10px;
        font-weight: 400;
      }
    }
  }

  .manage_buttons {
    min-width: 180px;
    margin-top: 10px;

    button:not(:first-child) {
      margin-left: 10px;
    }
  }
`;
